import Form from '../_.extend';
import { onSuccess, onError } from './utilities/formHooks';

// make fields
export const makeFields: Function = (t: Function) => {
  const fields = [
    'chooseAccount',
    'chooseAccount.tradingAccount',
    'rushAssetDetails',
    'rushAssetDetails[].assetTitle',
    'rushAssetDetails[].category',
    'rushAssetDetails[].description',
    'rushAssetDetails[].quantity',
    'rushAssetDetails[].descriptionCategory',
    'rushAssetDetails[].dataPlan',
    'rushAssetDetails[].software',
    'rushAssetDetails[].displays',
    'rushAssetDetails[].peripherals',
    'requiredDates',
    'requiredDates.startDate',
    'requiredDates.endDate',
    'assignProjects',
    'assignProjects.list',
    'assignCostCentre',
    'assignCostCentre.list',
    'additionalInformation',
    'additionalInformation.details',
    'customerDetails',
    'customerDetails.name',
    'customerDetails.phoneNo',
    'customerDetails.company',
    'customerDetails.site',
    'customerDetails.deliveryIsEqual',
    'deliveryDetails',
    'deliveryDetails.name',
    'deliveryDetails.phoneNo',
    'deliveryDetails.company',
    'deliveryDetails.site',
    'deliveryDetails.specialInstructions',
  ];
  const labels = {
    chooseAccount: t('general:actions.choose_trading_account'),
    'chooseAccount.tradingAccount': t('general:actions.choose_trading_account'),
    rushAssetDetails: t('general:assets.labels.details'),
    'rushAssetDetails[].assetTitle': 'Asset Title',
    'rushAssetDetails[].category': 'Category',
    'rushAssetDetails[].description': t('general:description'),
    'rushAssetDetails[].quantity': t('general:labels.quantity'),
    'rushAssetDetails[].dataPlan': 'Data Plan',
    'rushAssetDetails[].software': 'Software',
    'rushAssetDetails[].displays': 'Displays',
    'rushAssetDetails[].peripherals': 'Peripherals',
    requiredDates: t('general:labels.required_dates'),
    'requiredDates.startDate': t('general:labels.start_date'),
    'requiredDates.endDate': t('general:labels.end_date'),
    assignProjects: t('general:actions.assign_project'),
    'assignProjects.list': t('general:actions.choose_projects'),
    assignCostCentre: t('general:actions.assign_cost_center'),
    'assignCostCentre.list': t('general:actions.choose_cost_center'),
    additionalInformation: t('general:labels.actual_additional_information'),
    'additionalInformation.details': t('general:labels.actual_additional_information'),
    customerDetails: t('general:labels.customer_details'),
    'customerDetails.name': t('general:labels.contact_name'),
    'customerDetails.phoneNo': t('general:labels.contact_phone_number'),
    'customerDetails.company': t('general:company'),
    'customerDetails.site': t('general:locations.labels.site'),
    'customerDetails.deliveryIsEqual': t('general:actions.delivery_is_equal'),
    deliveryDetails: t('general:labels.delivery_details'),
    'deliveryDetails.name': t('general:labels.contact_name'),
    'deliveryDetails.phoneNo': t('general:labels.contact_phone_number'),
    'deliveryDetails.company': t('general:company'),
    'deliveryDetails.site': t('general:locations.labels.site'),
    'deliveryDetails.specialInstructions': t('general:labels.special_instructions'),
  };
  const rules = {
    'chooseAccount.tradingAccount': 'required',
    rushAssetDetails: 'required|array|min:1',
    'rushAssetDetails[].assetTitle': 'string',
    'rushAssetDetails[].category': 'string',
    'rushAssetDetails[].description': 'string',
    'rushAssetDetails[].descriptionCategory': 'string',
    'rushAssetDetails[].dataPlan': 'string',
    'rushAssetDetails[].quantity': 'integer',
    'rushAssetDetails[].software': 'array',
    'rushAssetDetails[].displays[]': 'array',
    'rushAssetDetails[].peripherals[]': 'array',
    'requiredDates.startDate': 'required|date',
    'requiredDates.endDate': 'required|date',
    'assignProjects.list': 'string',
    'assignCostCentre.list': 'string',
    additionalInformation: 'string',
    'customerDetails.phoneNo': 'telephone',
    'customerDetails.company': 'required|string',
    'customerDetails.site': 'required|string',
    'customerDetails.deliveryIsEqual': 'boolean',
    'deliveryDetails.phoneNo': 'telephone',
    'deliveryDetails.company': 'required|string',
    'deliveryDetails.site': 'required|string',
  };
  const extra = {
    'chooseAccount.tradingAccount': {
      selectID: '',
    },
    'rushAssetDetails[].category': {
      options: [{ name: 'No selection' }, { name: 'Laptops & Tablets' }],
    },
    'rushAssetDetails[].description': {
      setSelectedFields: [
        {
          field: 'description',
          value: 'id',
        },
        {
          field: 'assetTitle',
          value: 'ui_displayed_description',
        },
        {
          field: 'descriptionCategory',
          value: 'category',
        },
        {
          field: 'quantity',
          value: '',
          // Since Quantity is using an ElectroSimpleSelect, the value doesn't
          // get defaulted like the rest of the fields with the ElectroSelectExtra
          // component. This will set a custom value of 1 on the form.field directly
          // through the setSelected function of the extra select component,
          // updating our Quantity simple select.
          condition: {
            if: true,
            elseVal: 1,
          },
        },
      ],
    },
    'rushAssetDetails[].software': {
      setSelectedFields: [
        {
          field: 'software',
          value: 'id',
        },
      ],
    },
    'rushAssetDetails[].dataPlan': {
      setSelectedFields: [
        {
          field: 'dataPlan',
          value: 'id',
        },
      ],
    },
    'rushAssetDetails[].quantity': {
      options: Array.from({ length: 10 }, (_, i) => ({
        id: i + 1,
        name: i + 1,
      })),
    },
    assignProjects: {
      actionButton: true,
    },
    'assignProjects.list': {
      actionButton: true,
    },
    assignCostCentre: {
      actionButton: true,
    },
    'assignCostCentre.list': {
      actionButton: true,
    },
    'customerDetails.company': {
      selectID: '',
      actionButton: true,
      childExtraFilters: [
        {
          type: 'formField',
          formName: 'customerDetails',
          formField: 'company',
          isExtra: true,
          value: 'selectID',
        },
      ],
    },
    'customerDetails.site': {
      selectID: '',
      actionButton: true,
      childExtraFilters: [
        {
          type: 'formField',
          formName: 'customerDetails',
          formField: 'company',
          isExtra: true,
          value: 'selectID',
        },
        {
          type: 'string',
          value: '?parent_id=',
        },
      ],
    },
    'deliveryDetails.company': {
      selectID: '',
      parentId: '',
      actionButton: true,
      childExtraFilters: [
        {
          type: 'formField',
          formName: 'deliveryDetails',
          formField: 'company',
          isExtra: true,
          value: 'selectID',
        },
      ],
    },
    'deliveryDetails.site': {
      selectID: '',
      actionButton: true,
      childExtraFilters: [
        {
          type: 'formField',
          formName: 'deliveryDetails',
          formField: 'company',
          isExtra: true,
          value: 'selectID',
        },
        {
          type: 'string',
          value: '?parent_id=',
        },
      ],
    },
  };

  return { labels, fields, rules, extra };
};

// Form instance
class AssetRequestForm extends Form {}

// make hooks
export const createAssetRequestForm: Function = (
  fieldOptions: Array<*>,
  localState: Object,
  t: Function
) => {
  const { labels, fields, rules, extra } = fieldOptions;
  const hooks: Object = {
    onSuccess: onSuccess(fields, localState, t),
    onError: onError(fields, localState, t),
  };

  return new AssetRequestForm({ labels, fields, rules, extra }, { hooks });
};
